import { useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { convertToEasternISO, formatDateYMD, getDateDaysAgo } from '../../../../utils/dateFormatter'
import { getGameReportStart, getPlayerGameReportStart, getPlayerReportStart } from '../../../../store/redux-slices/dashboard'
import { getLoginToken } from '../../../../utils/storageUtils'
import useDidMountEffect from '../../../../utils/useDidMountEffect'

 import { getFileRequest } from '../../../../utils/axios'
import { toast } from '../../../../components/Toast'

const usePlayerReport = ({ selectedPortal, selectedClient }) => {
  const dispatch = useDispatch()
  const { PlayerReportLoading,
    PlayerReport } = useSelector((state) => state.dashboard)
  console.log({ PlayerReport }, "count >>> PlayerReport")
  const [selectedTab, setSelectedTab] = useState('game')
  const [search, setSearch] = useState('')
  const [hostSearch, setHostSearch] = useState('')
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(20)
  const isInitialRender = useDidMountEffect()
  const totalPages = Math.ceil(PlayerReport?.
    pagination?.totalPages)
  const [dateOptions, setDateOptions] = useState('')

  const [state, setState] = useState([
    {
      startDate: getDateDaysAgo(0),
      endDate: new Date(),
      key: 'selection'
    }
  ])

  const fetchDetails = (data) => {
    const startDate = convertToEasternISO(
      data?.action === "refresh"
        ? getDateDaysAgo(0)
        : state.map((a) => a.startDate)
    );
    const endDate = convertToEasternISO(
      data?.action === "refresh" ? new Date() : state.map((a) => a.endDate)
    );
    const searchString = data?.action === "refresh" ? "" : search;
    const searchHostString = data?.action === "refresh" ? "" : hostSearch;
    const date_options = data?.action === "refresh" ? "" : dateOptions;

    dispatch(getPlayerReportStart({
      isTenant: false,
      startDate,
      endDate,
      tenantId: selectedPortal,
      adminId: selectedClient,
      dateOptions: date_options,
      selectedTab,
      search: searchString,
      page,
      limit,
      hostSearch: searchHostString,
    }))
  }

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (!isInitialRender) {
        if (page === 1) {
          fetchDetails()
        } else {
          setPage(1)
        }
      }
    }, 1000)
    return () => clearTimeout(delayDebounceFn)
  }, [state, selectedClient, selectedPortal, selectedTab, dateOptions, search, hostSearch, limit])

  useEffect(() => {
    !isInitialRender && fetchDetails()
  }, [page])

  // useEffect(() => {
  //   if (dateOptions !== 'custom' && !isInitialRender) fetchDetails()
  // }, [dateOptions])

  useEffect(() => {
    fetchDetails()
  }, [])

  const getCsvDownloadUrl = () =>
    `${process.env.REACT_APP_API_URL}/api/admin/casino/player-reports?search=${search}&hostSearch=${hostSearch}&date=${dateOptions}&csvDownload=true&token=${getLoginToken()}`

  // const handleResetFilters = useCallback(() => {
  //   setSearch("");
  //   setHostSearch("");
  //   setState([{
  //     startDate: getDateDaysAgo(0),
  //     endDate: new Date(),
  //     key: "selection",
  //   }]);
  //   setDateOptions("");

  //   fetchDetails({ action: "refresh" });
  // }, []);

  const handleResetFilters = useCallback(() => {
    search !== "" && setSearch('')
    dateOptions !== "" && setDateOptions('')
    if (search === "" && dateOptions === "") {
      fetchDetails({ action: 'refresh' })

    }
  }, [search, dateOptions])


  const handleDownload = async (format = 'csv', transactionType) => {
    try {
      const response = await getFileRequest(getCsvDownloadUrl());

      const blob = new Blob([response.data?.data?.result?.csvData], { type: 'text/csv' });
      const downloadUrl = URL.createObjectURL(blob);

      const element = document.createElement('a');
      element.href = downloadUrl;
      element.download = `${transactionType}s_${format}_${new Date().toISOString().split('T')[0]}.csv`;
      element.style.display = 'none';

      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);

      URL.revokeObjectURL(downloadUrl);

      toast(`CSV downloaded successfully`, 'success');
    } catch (error) {
      console.error('Download error:', error);
      toast('Error downloading CSV', 'error');
    }
  };

  return {

    fetchDetails,
    loading: PlayerReportLoading,
    setState,
    state,
    selectedTab,
    setSelectedTab,
    PlayerReport,
    dateOptions,
    setDateOptions,
    getCsvDownloadUrl,
    search,
    setSearch,
    limit,
    setLimit,
    page,
    setPage,
    totalPages,
    hostSearch,
    setHostSearch,
    handleResetFilters,
    handleDownload
  }
}

export default usePlayerReport
